"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.platformSwitch = exports.platform = void 0;

var _runningPlatform = _interopRequireDefault(require("./runningPlatform"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var platform = {
  web: _runningPlatform["default"] === 'web',
  ios: _runningPlatform["default"] === 'ios',
  android: _runningPlatform["default"] === 'android'
};
exports.platform = platform;

var platformSwitch = function platformSwitch(_ref) {
  var web = _ref.web,
      _ref$ios = _ref.ios,
      ios = _ref$ios === void 0 ? null : _ref$ios,
      _ref$android = _ref.android,
      android = _ref$android === void 0 ? null : _ref$android,
      _ref$native = _ref["native"],
      _native = _ref$native === void 0 ? null : _ref$native;

  if (_native) return platform.web ? web : _native;
  var mobile = platform.android ? android : ios;
  return platform.web ? web : mobile;
};

exports.platformSwitch = platformSwitch;